export const iconFontAwesomeBuildingsSchoolCircleXmark = (
	<i className="fa-solid fa-school-circle-xmark"></i>
);
